import { OrgSummaryPreferences, DEFAULT_SUMMARY_PREFERENCES } from '@/types/summaryView';

export const SET_SUMMARY_APP_PREFERENCES = 'SET_SUMMARY_APP_PREFERENCES';
export const SET_SUMMARY_ORG_PREFERENCES = 'SET_SUMMARY_ORG_PREFERENCES';

export interface SetOrgSummaryAppPreferencesAction {
    type: typeof SET_SUMMARY_APP_PREFERENCES;
    payload: { appId: string; preferences: Partial<OrgSummaryPreferences> };
}

export interface SetOrgSummaryOrgPreferencesAction {
    type: typeof SET_SUMMARY_ORG_PREFERENCES;
    payload: { orgId: string; preferences: Partial<OrgSummaryPreferences> };
}

export const setOrgSummaryAppPreferences = (
    appId: string,
    preferences: Partial<OrgSummaryPreferences>,
): SetOrgSummaryAppPreferencesAction => ({
    type: SET_SUMMARY_APP_PREFERENCES,
    payload: { appId, preferences },
});

export const setOrgSummaryOrgPreferences = (
    orgId: string,
    preferences: Partial<OrgSummaryPreferences>,
): SetOrgSummaryOrgPreferencesAction => ({
    type: SET_SUMMARY_ORG_PREFERENCES,
    payload: { orgId, preferences },
});

export interface OrgSummaryPreferencesState {
    byAppId: Record<string, OrgSummaryPreferences>;
    byOrgId: Record<string, OrgSummaryPreferences>;
}

const initialState: OrgSummaryPreferencesState = {
    byAppId: {},
    byOrgId: {},
};

type OrgSummaryPreferencesActions = SetOrgSummaryAppPreferencesAction | SetOrgSummaryOrgPreferencesAction;

const mergePreferences = (
    current: OrgSummaryPreferences | undefined,
    updates: Partial<OrgSummaryPreferences>,
): OrgSummaryPreferences => {
    return {
        ...DEFAULT_SUMMARY_PREFERENCES,
        ...current,
        ...updates,
    };
};

const orgSummaryPreferencesReducer = (
    state: OrgSummaryPreferencesState = initialState,
    action: OrgSummaryPreferencesActions,
): OrgSummaryPreferencesState => {
    switch (action.type) {
        case SET_SUMMARY_APP_PREFERENCES: {
            const { appId, preferences } = action.payload;
            const existing = state.byAppId[appId];
            return {
                ...state,
                byAppId: {
                    ...state.byAppId,
                    [appId]: mergePreferences(existing, preferences),
                },
            };
        }
        case SET_SUMMARY_ORG_PREFERENCES: {
            const { orgId, preferences } = action.payload;
            const existing = state.byOrgId[orgId];
            return {
                ...state,
                byOrgId: {
                    ...state.byOrgId,
                    [orgId]: mergePreferences(existing, preferences),
                },
            };
        }
        default:
            return state;
    }
};

export default orgSummaryPreferencesReducer;
